import React from 'react';

/* WormHero.js — Vers-héros VertinGo : illustrations SVG ORIGINALES, 100% maison.
 * Aucune image externe, aucune IP : les variantes « évocation » suggèrent un archétype via un
 * élément signature GÉNÉRIQUE (chevelure hérissée, chapeau de paille, chauve + cape) ; les
 * variantes « VertinGo » sont des mascottes 100% originales (Vertix, Nova). */

// Corps de vers commun (mignon, style Worms) — dessiné une fois, décoré par variante.
function Body() {
  return (
    <g>
      <ellipse cx="50" cy="84" rx="23" ry="29" fill="#f2a6ae" stroke="#c56b76" strokeWidth="2.2" />
      <ellipse cx="50" cy="73" rx="19" ry="15" fill="#f8bfc5" />
      <ellipse cx="42" cy="70" rx="6.4" ry="7.8" fill="#fff" stroke="#c56b76" strokeWidth="1" />
      <ellipse cx="58" cy="70" rx="6.4" ry="7.8" fill="#fff" stroke="#c56b76" strokeWidth="1" />
      <circle cx="43.5" cy="72" r="2.6" fill="#20141a" />
      <circle cx="58.5" cy="72" r="2.6" fill="#20141a" />
      <path d="M44 84 q6 5 12 0" fill="none" stroke="#b0525d" strokeWidth="2" strokeLinecap="round" />
    </g>
  );
}

const VARIANTS = {
  // Évocation « super-guerrier » : chevelure dorée hérissée + aura d'énergie (archétype générique).
  superSaiyan: {
    name: 'Super-Guerrier',
    behind: (
      <g>
        <circle cx="50" cy="72" r="46" fill="url(#auraGold)" opacity="0.55" />
        <g stroke="#ffe58a" strokeWidth="2" opacity="0.8">
          <line x1="12" y1="40" x2="4" y2="30" /><line x1="88" y1="40" x2="96" y2="30" />
          <line x1="50" y1="16" x2="50" y2="4" />
        </g>
      </g>
    ),
    front: (
      <path d="M30 60 L33 30 L40 52 L47 24 L53 50 L60 26 L67 52 L72 34 L70 60 Z"
        fill="#ffcf3f" stroke="#e0a020" strokeWidth="1.8" strokeLinejoin="round" />
    ),
  },
  // Évocation « pirate » : chapeau de paille (objet générique).
  pirate: {
    name: 'Le Pirate',
    front: (
      <g>
        <ellipse cx="50" cy="58" rx="30" ry="8" fill="#e6c26a" stroke="#a9863a" strokeWidth="1.6" />
        <path d="M35 58 q15 -26 30 0 Z" fill="#f0d488" stroke="#a9863a" strokeWidth="1.6" />
        <rect x="35" y="52" width="30" height="4.4" rx="2" fill="#c0392b" />
      </g>
    ),
  },
  // Évocation « poing surpuissant » : crâne chauve (reflet) + cape (générique).
  puncher: {
    name: 'Le Poing',
    behind: (
      <path d="M28 66 L18 118 L82 118 L72 66 Q50 78 28 66 Z" fill="#c0392b" stroke="#8e2a20" strokeWidth="1.6" opacity="0.92" />
    ),
    front: (
      <ellipse cx="45" cy="60" rx="7" ry="4" fill="#fff" opacity="0.55" />
    ),
  },
  // Mascotte 100% VertinGo « Vertix » : visière cyan + antenne d'énergie, couleurs de marque.
  vertix: {
    name: 'Vertix',
    behind: (<circle cx="50" cy="72" r="44" fill="url(#auraBrand)" opacity="0.6" />),
    front: (
      <g>
        <path d="M30 63 q20 -14 40 0 l0 6 q-20 -8 -40 0 Z" fill="#22d3ee" stroke="#0e9fb5" strokeWidth="1.4" />
        <line x1="50" y1="52" x2="50" y2="40" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round" />
        <circle cx="50" cy="37" r="4.5" fill="#c084fc" stroke="#7c3aed" strokeWidth="1.5" />
      </g>
    ),
  },
  // Mascotte 100% VertinGo « Nova » : étoile sur le front + éclat, thème stellaire.
  nova: {
    name: 'Nova',
    behind: (
      <g fill="#fef08a" opacity="0.85">
        <path d="M14 30 l2 6 l6 2 l-6 2 l-2 6 l-2 -6 l-6 -2 l6 -2 Z" />
        <path d="M86 26 l1.6 5 l5 1.6 l-5 1.6 l-1.6 5 l-1.6 -5 l-5 -1.6 l5 -1.6 Z" />
      </g>
    ),
    front: (
      <path d="M50 44 l3.4 7 l7.6 1 l-5.5 5.3 l1.3 7.6 l-6.8 -3.6 l-6.8 3.6 l1.3 -7.6 l-5.5 -5.3 l7.6 -1 Z"
        fill="#ffd93b" stroke="#e0a800" strokeWidth="1.4" strokeLinejoin="round" />
    ),
  },
};

export const WORM_HEROES = Object.keys(VARIANTS).map((k) => ({ id: k, name: VARIANTS[k].name }));

export default function WormHero({ variant = 'superSaiyan', size = 120, title }) {
  const v = VARIANTS[variant] || VARIANTS.superSaiyan;
  return (
    <svg viewBox="0 0 100 120" width={size} height={size} role="img" aria-label={title || v.name}>
      <defs>
        <radialGradient id="auraGold" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fff3b0" /><stop offset="60%" stopColor="#ffcf3f" /><stop offset="100%" stopColor="#ffcf3f" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="auraBrand" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#c084fc" /><stop offset="55%" stopColor="#7c3aed" /><stop offset="100%" stopColor="#22d3ee" stopOpacity="0" />
        </radialGradient>
      </defs>
      {v.behind}
      <Body />
      {v.front}
    </svg>
  );
}
